import angular from 'angular';
import { IStateProvider } from 'angular-ui-router';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.maintenance').config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider: IStateProvider) {
  $stateProvider.state(STATE_MAPPINGS.maintenanceBusiness, {
    url: '/business',
    params: { title: 'Maintenance - Business' },
    views: {
      childcontent: {
        templateUrl:
          'Client/runner.maintenance/business/runner.maintenance.business.tmpl.html',
        controllerAs: '$ctrl',
        controller: 'maintenanceBusinessController'
      }
    }
  });
}
